// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1qtOm","requiredAsterisk":"Info_requiredAsterisk__23Gh0"};